<template>
  <login-form>
    <template v-slot:after>
      <div class="flags-block mt-4" style="width: 100%;">
        <div href="#"><img @click="changeLanguage('ru')" height="30px" style="border: 1px solid black" :src="require('@/../public/img/icons/countries/RU.svg')" alt="ru"/></div>
        <div href="#"><img @click="changeLanguage('kz')" height="30px" style="border: 1px solid black" :src="require('@/../public/img/icons/countries/KZ.svg')" alt="kz"/></div>
        <div href="#"><img @click="changeLanguage('en')" height="30px" style="border: 1px solid black" :src="require('@/../public/img/icons/countries/GB.svg')" alt="en"/></div>
      </div>
    </template>
  </login-form>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'
import LoginForm from '../common/components/auth/LoginForm.vue'
import ApiClient from '@/helpers/api-client/ApiClient'
import viewTranslationMixin from '@/mixins/viewTranslationMixin'

export default {
  name: 'Login',

  mixins: [
    mainMixin,
    viewTranslationMixin
  ],

  components: {
    LoginForm
  },

  created () {
    this.hidePreloader()
  },

  methods: {
    changeLanguage (language) {
      ApiClient.changeUserLanguage(language)
        .then(() => {
          this.getTranslations()
          this.$i18n.locale = language
          localStorage.setItem('language', language)
        })
    }
  }
}
</script>
